<span [ngClass]="{selected:isSelected}" (click)="onSelect()">@if (showCheckbox) {
  <input type="checkbox" [checked]="isSelected">
}{{ domain.name }}</span>
